const NoMoviesFound = () => {
    return (
        <div className={"fs-5 text-center p-2"}>Sorry, no movies are found</div>
    )
};
export default NoMoviesFound;